<template>
    <div class="mt-1">
        <div class="col-12 mt-2">

            <select class="form-control form-control-sm" v-model="search.time" @change="onDropdownChange">
                <option value="0">Bonus Seçiniz</option>
                <option v-for="data in timeFilters" :key="data.name" :value="data.value">{{ data.name
                    }}</option>
            </select>
        </div>

        <div class="col-12" v-if="datas != null">
            <div class="col-12">
                <div class="row my-3">
                    <div class="col-4"><b class="pr-5">Yatırma Tutarı: {{
                        datas.deposits.amount || 0 }} TL </b></div>
                    <div class="col-4"><b class="pr-5">Toplam Çekim Tutarı: {{
                        datas.withdraws.amount || 0 }} TL</b></div>
                    <div class="col-4"><b>Fark (Yatırım - Çekim): {{ datas.difference || 0 }}
                            TL</b></div>
                </div>
                <table class="table table-striped projects">
                    <thead>
                        <tr>
                            <th>Müşteri Kodu</th>
                            <th>Durum</th>
                            <th>İstek / Sonuç Zamanı</th>
                            <th>Bonusu</th>
                            <th>İşlem Miktarları</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in requests" :key="index">
                            <td>{{ data.customerCode }}</td>
                            <td>
                                <badge :type="data.status ? 'success' : 'danger'"
                                    :label="data.status ? 'Bonus Verildi' : 'Bonus Verilmedi'" />
                            </td>
                            <td>
                                {{ data.date }}
                            </td>
                            <td>{{ data.bonusName }}</td>

                            <td>
                                <span>
                                    {{ data.amount || 0 }} TL
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>


<script>
import Badge from '../Common/Badge'

export default {
    components: {
        'badge': Badge,
    },
    props: {
        customerCode: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            datas: null,
            requests: null,
            search: {
                time: 1
            },
            timeFilters: [
                { name: 'Son 7 Gün', value: 1 },
                { name: 'Son 15 Gün', value: 2 },
                { name: 'Son 30 Gün', value: 3 },
                { name: 'Bu ay', value: 4 },
                { name: 'Son 6 Ay', value: 5 },
                { name: 'Tüm Zamanlarda', value: 6 }
            ]
        };
    },
    mounted() {
        this.search.time = 1;
        this.GetCustomerInfo();
    },
    methods: {

        GetCustomerInfo() {
            if (this.customerCode != null && this.customerCode != "") {
                this.$http.get(`Report/GetCustomerStatistics/?customerCode=${this.customerCode}&type=${this.search.time}`).then(response => {
                    this.datas = response.data;
                    this.requests = response.data.requests;
                });
            }
        },
        onDropdownChange(event) {
            this.GetCustomerInfo();
        }
    },
    filters: {
    }
};
</script>


// WEBPACK FOOTER //
// src/components/UserProfile/UserStatistics.vue